export const tvShows = [
  {
    id: 't-001',
    title: '长安十二辰',
    type: 'tv',
    genres: ['历史', '古装'],
    year: 2024,
    region: '中国大陆',
    seasons: 2,
    episodes: 48,
    rating: 9.0,
    director: '顾长风',
    cast: ['裴行舟', '苏墨白', '长孙嫣'],
    summary:
      '上元灯节前夜，长安城收到一封匿名的告急密信，称十二个时辰之内将有大变。一名被贬的旧日廷尉必须在灯火亮起之前，穿过整座城找出那双藏在人群里的手。',
    poster:
      'https://readdy.ai/api/search-image?query=Grand%20historical%20Chinese%20drama%20poster%20of%20the%20ancient%20walled%20city%20of%20Chang%20an%20at%20dusk%20seen%20from%20above%20red%20lanterns%20and%20tiled%20roofs%20deep%20navy%20blue%20night%20sky%20with%20warm%20orange%20lantern%20light%20imperial%20cinematic%20atmosphere%20premium%20period%20drama%20poster%20illustration&width=400&height=600&seq=tv001p&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%20of%20the%20ancient%20Chinese%20capital%20city%20of%20Chang%20an%20at%20dusk%20layered%20palace%20roofs%20and%20city%20walls%20glowing%20warm%20orange%20lanterns%20under%20a%20deep%20navy%20blue%20sky%20imperial%20grandeur%20ultra%20detailed%20cinematic%20color%20grading&width=1600&height=900&seq=tv001b&orientation=landscape',
    views: 2103000,
    featured: true,
  },
  {
    id: 't-002',
    title: '迷雾档案',
    type: 'tv',
    genres: ['犯罪', '悬疑'],
    year: 2023,
    region: '中国大陆',
    seasons: 3,
    episodes: 32,
    rating: 8.5,
    director: '罗敬之',
    cast: ['秦砚', '白也', '苏未晞'],
    summary:
      '档案室最深处有一批编号断档的旧卷宗。年轻的女警察在整理它们时发现，每一份看似无关的悬案，都能拼出同一个人的人生轨迹。',
    poster:
      'https://readdy.ai/api/search-image?query=Modern%20crime%20drama%20poster%20of%20a%20detective%20desk%20covered%20with%20case%20files%20a%20single%20warm%20orange%20desk%20lamp%20deep%20navy%20blue%20shadowy%20room%20a%20blurred%20city%20map%20behind%20tense%20mysterious%20atmosphere%20cinematic%20noir%20poster%20illustration&width=400&height=600&seq=tv002p&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%20of%20a%20dim%20detective%20office%20at%20night%20files%20and%20a%20case%20board%20with%20a%20city%20map%20a%20warm%20orange%20desk%20lamp%20glow%20deep%20navy%20blue%20shadows%20tense%20mysterious%20atmosphere%20ultra%20detailed%20cinematic%20color%20grading&width=1600&height=900&seq=tv002b&orientation=landscape',
    views: 1672000,
  },
  {
    id: 't-003',
    title: '心动的信号线',
    type: 'tv',
    genres: ['爱情', '都市'],
    year: 2024,
    region: '韩国',
    seasons: 1,
    episodes: 16,
    rating: 7.8,
    director: '车秀贤',
    cast: ['尹世罗', '姜睦', '全夏恩'],
    summary:
      '一位信号灯维修师与一位深夜电台主播，因为一条总在凌晨亮起的故障路灯相遇。他们把说不出口的心事，都藏进了一盏灯的开与关之间。',
    poster:
      'https://readdy.ai/api/search-image?query=Soft%20romantic%20Korean%20drama%20poster%20of%20a%20cozy%20pastel%20cafe%20interior%20with%20warm%20orange%20fairy%20lights%20two%20shy%20young%20people%20sitting%20apart%20gentle%20bokeh%20deep%20navy%20blue%20evening%20tones%20tender%20sweet%20atmosphere%20elegant%20romance%20drama%20poster%20illustration&width=400&height=600&seq=tv003p&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%20of%20a%20cozy%20cafe%20at%20evening%20soft%20warm%20orange%20string%20lights%20and%20gentle%20bokeh%20two%20young%20people%20sitting%20quietly%20deep%20navy%20blue%20dusk%20tones%20through%20the%20window%20tender%20romantic%20atmosphere%20ultra%20detailed%20cinematic%20color%20grading&width=1600&height=900&seq=tv003b&orientation=landscape',
    views: 1255000,
  },
  {
    id: 't-004',
    title: '权力的边缘',
    type: 'tv',
    genres: ['剧情', '历史'],
    year: 2022,
    region: '美国',
    seasons: 5,
    episodes: 60,
    rating: 9.2,
    director: '格雷格·穆尔',
    cast: ['艾登·凯斯特', '玛拉·霍桑', '卢卡斯·拜恩'],
    summary:
      '北境王座空缺的第十年，三大家族在旧盟约的废墟上重新结盟又相互背叛。所有人都以为自己在下一盘棋，却没人知道棋盘早已被换过。',
    poster:
      'https://readdy.ai/api/search-image?query=Epic%20political%20drama%20poster%20of%20a%20grand%20dimly%20lit%20throne%20room%20with%20towering%20stone%20columns%20deep%20navy%20blue%20shadows%20and%20a%20beam%20of%20warm%20orange%20light%20from%20a%20high%20window%20imposing%20powerful%20atmosphere%20premium%20period%20drama%20poster%20illustration&width=400&height=600&seq=tv004p&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%20of%20a%20vast%20grand%20throne%20hall%20towering%20stone%20columns%20fading%20into%20deep%20navy%20blue%20darkness%20a%20dramatic%20beam%20of%20warm%20orange%20light%20from%20a%20high%20window%20imposing%20powerful%20atmosphere%20ultra%20detailed%20cinematic%20color%20grading&width=1600&height=900&seq=tv004b&orientation=landscape',
    views: 2890000,
    featured: true,
  },
  {
    id: 't-005',
    title: '三体之外',
    type: 'tv',
    genres: ['科幻', '悬疑'],
    year: 2025,
    region: '中国大陆',
    seasons: 1,
    episodes: 30,
    rating: 8.7,
    director: '严之澜',
    cast: ['陆沉', '江晚', '纪雪'],
    summary:
      '一支国际观测团队在太阳系边缘发现了一个正在缓慢减速的未知构造体。随着它的接近，人类第一次意识到，宇宙的沉默或许不是空无，而是注视。',
    poster:
      'https://readdy.ai/api/search-image?query=Grand%20sci-fi%20series%20poster%20of%20the%20Earth%20glowing%20blue%20at%20the%20edge%20of%20a%20vast%20dark%20cosmos%20a%20giant%20alien%20structure%20approaching%20deep%20navy%20blue%20space%20with%20warm%20orange%20cosmic%20light%20awe%20inspiring%20epic%20atmosphere%20premium%20sci-fi%20series%20poster%20illustration&width=400&height=600&seq=tv005p&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20sci-fi%20series%20still%20of%20planet%20Earth%20glowing%20in%20the%20distance%20of%20a%20vast%20deep%20navy%20blue%20cosmos%20a%20colossal%20mysterious%20structure%20approaching%20warm%20orange%20cosmic%20light%20awe%20inspiring%20epic%20scale%20ultra%20detailed%20cinematic%20color%20grading&width=1600&height=900&seq=tv005b&orientation=landscape',
    views: 1989000,
    featured: true,
  },
  {
    id: 't-006',
    title: '少年侦探手记',
    type: 'tv',
    genres: ['悬疑', '青春'],
    year: 2023,
    region: '日本',
    seasons: 2,
    episodes: 24,
    rating: 8.1,
    director: '小林苍',
    cast: ['神谷悠', '早濑美绪', '御影陆'],
    summary:
      '转学生在一间废弃的社团教室里，翻到一本前前任社长的推理手记。手记里的最后一个案子没有写完，而它的线索，正指向这所学校本身。',
    poster:
      'https://readdy.ai/api/search-image?query=Youth%20mystery%20drama%20poster%20of%20a%20bright%20teenage%20detective%20with%20a%20magnifying%20glass%20in%20a%20warmly%20lit%20classroom%20after%20school%20deep%20navy%20blue%20evening%20outside%20the%20window%20curious%20playful%20atmosphere%20charming%20Japanese%20drama%20poster%20illustration&width=400&height=600&seq=tv006p&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%20of%20a%20warm%20classroom%20after%20school%20a%20teenage%20detective%20examining%20clues%20under%20warm%20orange%20light%20deep%20navy%20blue%20dusk%20visible%20through%20the%20windows%20curious%20playful%20atmosphere%20ultra%20detailed%20cinematic%20color%20grading&width=1600&height=900&seq=tv006b&orientation=landscape',
    views: 812000,
  },
  {
    id: 't-007',
    title: '家族的秘密',
    type: 'tv',
    genres: ['剧情', '悬疑'],
    year: 2024,
    region: '英国',
    seasons: 3,
    episodes: 40,
    rating: 8.4,
    director: '奥利维娅·班克斯',
    cast: ['埃莉诺·霍尔', '詹姆斯·惠特', '克拉拉·芬恩'],
    summary:
      '老庄园的主人去世后，遗产继承的名单里多出一个所有人都不认识的名字。为了查清这个人是谁，一个贵族家族不得不再一次翻开他们最不愿提起的旧账。',
    poster:
      'https://readdy.ai/api/search-image?query=British%20period%20drama%20poster%20of%20a%20grand%20old%20stone%20mansion%20in%20mist%20warm%20orange%20lit%20windows%20deep%20navy%20blue%20overcast%20sky%20formal%20garden%20in%20the%20foreground%20secretive%20aristocratic%20atmosphere%20premium%20period%20drama%20poster%20illustration&width=400&height=600&seq=tv007p&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%20of%20a%20grand%20old%20English%20stone%20mansion%20in%20morning%20mist%20warm%20orange%20light%20glowing%20from%20tall%20windows%20deep%20navy%20blue%20overcast%20sky%20formal%20gardens%20in%20front%20secretive%20aristocratic%20atmosphere%20ultra%20detailed%20cinematic%20color%20grading&width=1600&height=900&seq=tv007b&orientation=landscape',
    views: 1401000,
  },
  {
    id: 't-008',
    title: '江湖夜雨十年灯',
    type: 'tv',
    genres: ['武侠', '古装'],
    year: 2023,
    region: '中国大陆',
    seasons: 2,
    episodes: 36,
    rating: 8.6,
    director: '燕归尘',
    cast: ['沈无咎', '白雪衣', '柳听风'],
    summary:
      '十年前的一场雨夜里，江湖第一剑客销声匿迹。十年后，一个背着旧剑的陌生少年走进同一座城，只为问一句：那盏灯，究竟是谁为谁留的。',
    poster:
      'https://readdy.ai/api/search-image?query=Wuxia%20martial%20arts%20drama%20poster%20of%20a%20lone%20swordsman%20standing%20in%20pouring%20rain%20on%20an%20ancient%20stone%20bridge%20flowing%20robes%20deep%20navy%20blue%20night%20with%20warm%20orange%20lantern%20glow%20poetic%20heroic%20atmosphere%20elegant%20Chinese%20wuxia%20poster%20illustration&width=400&height=600&seq=tv008p&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%20of%20a%20lone%20swordsman%20in%20flowing%20robes%20standing%20on%20an%20ancient%20stone%20bridge%20in%20heavy%20rain%20at%20night%20deep%20navy%20blue%20tones%20with%20warm%20orange%20lantern%20glow%20reflecting%20on%20wet%20stone%20poetic%20heroic%20atmosphere%20ultra%20detailed%20cinematic%20color%20grading&width=1600&height=900&seq=tv008b&orientation=landscape',
    views: 1526000,
  },
  {
    id: 't-009',
    title: '都市浮世绘',
    type: 'tv',
    genres: ['喜剧', '都市'],
    year: 2024,
    region: '中国大陆',
    seasons: 2,
    episodes: 28,
    rating: 7.5,
    director: '方既明',
    cast: ['钱多多', '谈小可', '郝运'],
    summary:
      '一栋老写字楼里挤着十几种职业、一百多个不着调的梦想。出租屋、加班、相亲、创业……所有大城市里最普通的日子，凑在一起竟成了一出喜剧。',
    poster:
      'https://readdy.ai/api/search-image?query=Urban%20ensemble%20comedy%20drama%20poster%20of%20colorful%20city%20nightlife%20with%20a%20lively%20group%20of%20friends%20laughing%20on%20a%20rooftop%20deep%20navy%20blue%20night%20skyline%20warm%20orange%20city%20light%20vibrant%20energetic%20atmosphere%20modern%20TV%20drama%20poster%20illustration&width=400&height=600&seq=tv009p&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%20of%20a%20lively%20city%20rooftop%20at%20night%20a%20group%20of%20friends%20laughing%20together%20above%20a%20glowing%20skyline%20deep%20navy%20blue%20sky%20warm%20orange%20city%20lights%20vibrant%20energetic%20atmosphere%20ultra%20detailed%20cinematic%20color%20grading&width=1600&height=900&seq=tv009b&orientation=landscape',
    views: 934000,
  },
  {
    id: 't-010',
    title: '遥远的地平线',
    type: 'tv',
    genres: ['冒险', '剧情'],
    year: 2022,
    region: '美国',
    seasons: 4,
    episodes: 45,
    rating: 8.2,
    director: '汉娜·科尔',
    cast: ['欧文·格雷', '西尔维娅·诺', '德文·克莱'],
    summary:
      '一支由学者、向导与逃亡者组成的小队，沿着一条早已废弃的铁路线一路向西。他们要去的不是某个地方，而是一个足够远、足以重新开始的地平线。',
    poster:
      'https://readdy.ai/api/search-image?query=Epic%20adventure%20series%20poster%20of%20a%20small%20group%20of%20travelers%20on%20a%20vast%20open%20plain%20facing%20a%20distant%20glowing%20horizon%20deep%20navy%20blue%20sky%20warm%20orange%20sunrise%20light%20sense%20of%20journey%20and%20wonder%20cinematic%20adventure%20poster%20illustration&width=400&height=600&seq=tv010p&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%20of%20a%20small%20band%20of%20travelers%20crossing%20a%20vast%20open%20plain%20toward%20a%20distant%20glowing%20horizon%20deep%20navy%20blue%20sky%20warm%20orange%20sunrise%20light%20epic%20sense%20of%20journey%20and%20wonder%20ultra%20detailed%20cinematic%20color%20grading&width=1600&height=900&seq=tv010b&orientation=landscape',
    views: 1188000,
  },
];